
import { defineComponent } from "vue";

export default defineComponent({
  name: "Header",
  props: {
    todosLength: {
      type: Number,
      required: true,
    },
  },
});
